export default __webpack_public_path__ + "static/media/Sec6P4.1afa1d29.svg";